import { render, staticRenderFns } from "./PView.vue?vue&type=template&id=e76ce47c"
import script from "./PView.vue?vue&type=script&lang=js"
export * from "./PView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports